import { render, staticRenderFns } from "./RFIDConfigurator.vue?vue&type=template&id=01fae87f"
import script from "./RFIDConfigurator.vue?vue&type=script&lang=js"
export * from "./RFIDConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports